import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { formatNumber, registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es-CO';

import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';

import { UtilidadMenuEstadisticas } from '../../shared/utilities/utilidad-menu-estadisticas';
import { DetalleSerieDialogComponent } from '../../home/dialog/detalle-serie-dialog/detalle-serie-dialog.component';
import { Constantes } from '../../shared/constant/constantes';
import { NotaFeErrataComponent } from '../dialog/nota-fe-errata/nota-fe-errata.component';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { SerieEstadistica } from '../../shared/entities/serie-estadistica';
import { GraficaSerie } from '../../shared/utilities/grafica-serie';
import { UtilidadExportXLSX } from '../../shared/utilities/utilidad-exportxlsx';
import { InformacionIBR } from '../../shared/entities/informacion-ibr';
import { TablaDatosSerie } from '../../shared/utilities/tabla-datos-serie';
import { EncuestaComponent } from './encuesta/encuesta.component';
import { EncuestaSatisfaccion } from '../../shared/entities/EncuestaSatisfaccion';
import { HeaderComponent } from '../../shared/header/header.component';
import { MenuAlternoComponent } from '../public/menu-alterno/menu-alterno.component';
import { MercadoCambiarioComponent } from '../mercado-cambiario/mercado-cambiario.component';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { GraficaAnaliticaComponent } from '../grafica-analitica/grafica-analitica.component';
import { MatIconModule } from '@angular/material/icon';

registerLocaleData(es, 'co-ES');

@Component({
  selector: 'app-informacion-serie',
  templateUrl: './informacion-serie.component.html',
  styleUrls: ['./informacion-serie.component.css'],
  standalone: true,
  imports: [HeaderComponent, GraficaAnaliticaComponent, MenuAlternoComponent, HighchartsChartModule, MercadoCambiarioComponent, CommonModule, CdkDrag, MatIconModule]
})
export class InformacionSerieComponent implements OnInit {

  public utilidadMenuEstadisticas = UtilidadMenuEstadisticas.getInstance();
  public constante: Constantes = new Constantes();
  public idMenuSerie: string = '';
  public titulo: string = '';
  public subtitulo: string = '';
  public urlDashboard: string = '';

  public annioActual: number = 0;
  public annioAnterior: number = 0;

  public tilePaginator: Array<any> = new Array();
  public mostrarGrafico: string = 'grafico';
  public mostrarTabla: string = '';

  public informacionSerieSelected: SerieEstadistica = new SerieEstadistica();
  public webMenuSelected: any;
  public listaInformacionSeries: Array<SerieEstadistica> = new Array();
  public idSerie: number = 0;
  public listaIds: Array<number> = new Array();
  public idsSerieGraficador: string = '';

  public valor: string = '';
  public unidad: string = '';
  public nombre: string = '';
  public tipoTasa: string = '';
  public fecha: string = '';
  public unidadCorta: string = '';

  public estiloFrameGrafico: string = 'frame_graph';

  /** Tablas IBR*/
  private tds: TablaDatosSerie = new TablaDatosSerie();
  public participantesIBR: Array<InformacionIBR> = this.tds.getParticipantesDefault();

  /** Highcharts*/
  private chart?: Highcharts.Chart;
  public chartOptions: Highcharts.Options | null = null;
  public HighchartsIBR = Highcharts;

  public updateFlag: boolean = true;
  public listaSerieChart: Array<Highcharts.SeriesOptionsType> = new Array();
  public mostrarChart: string = 'chartSeries';

  public botonTabla: boolean = true;

  public urlServidorExport: string = '';
  public urlHistorico!: string;
  public urlIndicadores!: string;
  public urlBuscador!: string;
  public urlGraficador!: string;

  public encuesta: EncuestaSatisfaccion = new EncuestaSatisfaccion();
  public fechaInicio: Date = new Date();

  public cargando: boolean = false;
  public estiloChart: string = 'cardContenido div-chart';

  @ViewChild('draggableDiv', { static: false })
  public draggableDiv!: ElementRef;

  public dragPosition = { x: 0, y: 0 };

  public decimales: number = 2;

  public seccion: string = '';
  public grafica: string = '';
  public botonGraficaInicial = '';
  public botonGraficaDinamica = '';
  public botonGraficaExtra = '';

  public showtable: boolean = false;
  public nombreBotonTabla: string = 'Vista tabla';

  constructor(private router: Router, public sanitizer: DomSanitizer, public dialog: MatDialog, private service: VisualizadorService, private route: ActivatedRoute, private location: Location, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    this.consultarURLServidorExport(this.constante.PROPIEDAD_SERVIDOR_EXPORTACION);
    this.consultarURLBuscador();
    this.consultarURLGraficador();
    this.consultarURLHistorico();
    this.consultarURLIndicadores();
    this.iniciarProcesoGrafica();
  }

  iniciarProcesoGrafica(): void {
    const currentUrl = this.location.path();
    this.cargando = true;
    //this.configInitlHighcharts();
    this.idMenuSerie = this.route.snapshot.paramMap.get('idMenu')!;
    var t = this.NormalizarTitulos(this.route.snapshot.paramMap.get('titulo')!);
    var st = this.NormalizarTitulos(this.route.snapshot.paramMap.get('subtitulo')!);
    if (this.idMenuSerie === '1') {
      this.service.generaTagsHtmlSEO('Tasa de cambio del peso Colombiano por dolar USD - COP - TRM hoy', 'Información de las series del Banco de la República', 'catálogo, datos', currentUrl);
    }
    this.titulo = t;
    this.subtitulo = this.mostrartitulo(st, Number(this.idMenuSerie));
    let mapaWebMenu = new Map<string, string>();

    if (this.idMenuSerie === '1.1') {
      this.mostrarChart = 'mercadoCambiario';
    } else {
      if (isPlatformBrowser(this.platformId)) {
        this.initComponentsHighcharts();
      }
      this.service.getInformacionMenu(this.idMenuSerie!).subscribe({
        next: (jsonWebMenu) => {
          for (var value in jsonWebMenu) {
            mapaWebMenu.set(value, jsonWebMenu[value]);
          }
          let serieMenu: any = mapaWebMenu.get('MENU');
          this.webMenuSelected = serieMenu;
          this.generarTitulos(this.webMenuSelected);
          var nombreTitulo: string = '';
          if (this.idMenuSerie === '1') {
            nombreTitulo = "Tasa de cambio del peso Colombiano por dolar USD - COP - TRM hoy";
          } else {
            nombreTitulo = this.webMenuSelected.nombre;
          }
          let listaSerie: any = mapaWebMenu.get('SERIES');
          const currentUrl = this.location.path();
          this.service.generaTagsHtmlSEO(nombreTitulo, listaSerie[0].definicion, listaSerie[0].palabrasClave, currentUrl);

          this.generaInformacionSerie(serieMenu, listaSerie);
          this.cargando = false;
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    }
  }

  private async initComponentsHighcharts() {
    const Highcharts = await import('highcharts');
    await import('highcharts/modules/exporting');
    await import('highcharts/modules/export-data');
    await import('highcharts/modules/offline-exporting');
    await import('highcharts/modules/accessibility');
    //Highcharts = Highcharts;
  }

  private generaInformacionSerie(serieMenu: any, listaSerie: Array<any>) {
    this.listaInformacionSeries = listaSerie;
    this.getListaIds(serieMenu);
    this.urlDashboard = serieMenu.enlace_dashboard;
    this.configuraDatosEstadisticas(serieMenu, listaSerie);
  }

  private getListaIds(menu: any) {
    const separate = ",";
    const valuesId: string = menu.enlace_pagina_externa;
    if (this.utilidadMenuEstadisticas.esNumero(valuesId) == false) {
      if (valuesId.includes(separate)) {
        this.idsSerieGraficador = valuesId;
        var arrayIds: string[] = valuesId.split(separate);
        arrayIds.forEach(element => {
          this.listaIds.push(Number(element));
        });
        this.idSerie = this.listaIds[0];
      } else {
        let idTRM: number = menu.id | 0;
        this.listaIds.push(idTRM);
        this.idSerie = idTRM;
        this.idsSerieGraficador = idTRM + '';
      }
    } else {
      this.listaIds.push(Number(valuesId));
      this.idSerie = Number(valuesId);
      this.idsSerieGraficador = valuesId;
    }
  }

  private configuraDatosEstadisticas(serieMenu: any, lista: any) {
    this.botonGraficaDinamica = '';
    this.botonGraficaInicial = '';
    try {
      this.estiloFrameGrafico = 'frame_graph';
      this.mostrarTabla = 'none';
      switch (serieMenu.idMenuJson) {
        case 'PRECIOS_E_INFLACION':
          this.botonGraficaDinamica = 'PI-BARRACE';
          this.botonGraficaExtra = 'PI-SPIDER';
          this.getSeriesXDivision();
          this.tileVisualizador(this.listaIds);
          var opposite: boolean = false;
          if ('IPVU_TRIM' == serieMenu.idCarguePlan) {
            opposite = true;
          }
          this.dibujarGrafico('chartSeries', lista, opposite);
          break;
        case 'TASAS_INTERES_Y_SECTOR_FINAN':
          this.botonGraficaDinamica = 'TISF';
          if ([241, 242, 243].includes(this.idSerie)) { //Si las series que se van a graficar incluyen alguna de esas 3 series de IBR
            let idSeriesIBR = '241,15324,242,15325,243,15326,16560,16561,16562,16563';
            this.service.getInformacionSerie(idSeriesIBR!).subscribe({
              next: (listaSerie) => {
                this.participantesIBR.forEach(pibr => {
                  listaSerie.forEach(s => {
                    if (pibr.periodicidad == s.periodoReferencia) {
                      pibr.fecha = s.fecha;
                      pibr.unidad = s.unidadCorta;
                      if (s.nombre.includes('efectiva')) {
                        pibr.valorEfectiva = s.valor;
                      } else {
                        pibr.valorNominal = s.valor;
                      }
                    }
                    let chart = this.tds.graficarSerie(pibr);
                    pibr.graficoIBR = chart;
                  });
                });
              },
              error: (error) => {
                console.log("Error inesperado en getInformacionMenu", error);
              }
            });
            this.service.getParticipantesIbr().subscribe({
              next: (participantesIbr) => {
                for (let participante of participantesIbr) {
                  for (let participanteDefault of this.participantesIBR) {
                    if (participanteDefault.id === participante.plazo) {
                      participante.entidades.sort((a: any, b: any) => a.nombre.localeCompare(b.nombre));
                      for (let entidad of participante.entidades) {
                        entidad.valor = formatNumber(Number(entidad.valor), 'co-ES', '1.' + 3 + '-' + 3);
                      }
                      participanteDefault.tablaIBR = participante;
                    }
                  }
                }

              },
              error: (error) => {
                console.log("Error inesperado en getInformacionMenu", error);
              }
            });
            this.mostrarTabla = 'showTable';
          }
          this.tileVisualizador(this.listaIds);
          this.dibujarGrafico('chartSeries', lista, false);
          break;
        case 'SECTOR_EXT_TASAS_CAMBIO_Y_DERIV':
          this.botonGraficaDinamica = 'SETCD';
          if ('TASA_CAMBIO_PAISES_VECINOS' == serieMenu.idSubmenuJson) {
            this.tileVisualizador(this.listaIds);
            this.dibujarGrafico('chartSeries', lista, false);
            break;
          } else if ('BALANZA_PAGOS' == serieMenu.idSubmenuJson) {
            this.estiloFrameGrafico = 'frame_graph_double';
            this.tileVisualizador(this.listaIds);
            this.dibujarGrafico('chartSeries', lista, false);
            break;
          } else {
            this.tileVisualizador(this.listaIds);
            this.dibujarGrafico('chartSeries', lista, false);
            break;
          }
        case 'OPER_BANCO_MERCADO_Y_RESERV_INTERNAL':
          this.dibujarGrafico('chartSeries', lista, false);
          this.tileVisualizador(this.listaIds);
          break;
        case 'ACTIV_ECONOM_MERC_LABOR_Y_CTAS_FINAN':
          this.tileVisualizador(this.listaIds);
          this.dibujarGrafico('chartSeries', lista, false);
          break;
        case 'SECTOR_PUBLICO_Y_DEUDA_PUBLICA':
          var opposite: boolean = false;
          if ('TES_BID_ASK' == serieMenu.idCarguePlan) {
            opposite = true;
          }
          this.tileVisualizador(this.listaIds);
          this.dibujarGrafico('chartSeries', lista, opposite);
          break;
        default:
          this.tileVisualizador(this.listaIds);
          this.dibujarGrafico('chartSeries', lista, false);
          break;
      }
      this.showSlides(1, 1);
    } catch (error) {
      console.error(error);
    }
  }

  private dibujarGrafico(mostrarChart: string, listaSerie: any, opposite: boolean) {
    try {
      this.mostrarChart = mostrarChart;
      if ('chartSeries' == mostrarChart) {
        if (isPlatformBrowser(this.platformId)) {
          this.loadHighcharts(listaSerie, opposite);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async loadHighcharts(listaSeries: any[], opposite: boolean) {
    let gs: GraficaSerie = new GraficaSerie();

    let listaSerieChart: Array<Highcharts.Series> = new Array();
    let periodicidadPrincipal: number = 0;
    let periodicidadDescripcion: string = '';
    let unidadesMedida: string = '';
    let titulo: string = '';
    //let numY:number=0;
    let seriesAxisPosition = this.assignSeriesToYAxis(listaSeries);
    listaSeries.forEach(se => {
      let numY: number = seriesAxisPosition[se.id] ? 1 : 0;
      const ns: Highcharts.Series = this.getSerieChart(se, numY);
      listaSerieChart.push(ns);
      //this.listaSerieChart.push(ns);
      this.unidadCorta = se.unidadCorta;
      if (periodicidadPrincipal === 0 || se.idPeriodicidad < periodicidadPrincipal) {
        periodicidadPrincipal = se.idPeriodicidad;
        periodicidadDescripcion = se.descripcionPeriodicidad;
      }
      titulo = this.validarTitulo();
    });

    this.chartOptions = gs.getHighchartsOptions(listaSerieChart, periodicidadPrincipal, periodicidadDescripcion, titulo, seriesAxisPosition);
    if (this.chart) {
      this.chart.update(this.chartOptions);
    }
    this.chartOptions.exporting = this.exportChart(titulo, this.urlServidorExport);
    this.chartOptions.tooltip = gs.getTooltipOptions();
    this.chartOptions.legend = gs.getLegendOptions();
    this.chart = Highcharts.chart('containerSeries', this.chartOptions);
  }

  public mostrarGraficaDinamica(tipo: string) {
    this.botonGraficaDinamica = '';
    this.botonGraficaExtra = '';
    switch (tipo) {
      case 'INICIAL':
        this.grafica = '';
        this.botonGraficaInicial = '';
        if ('PRECIOS_E_INFLACION' == this.webMenuSelected.idMenuJson) {
          this.botonGraficaDinamica = 'PI-BARRACE';
          this.botonGraficaExtra = 'PI-SPIDER';
        } else if ('TASAS_INTERES_Y_SECTOR_FINAN' == this.webMenuSelected.idMenuJson) {
          this.botonGraficaDinamica = 'TISF';
        } else if ('SECTOR_EXT_TASAS_CAMBIO_Y_DERIV' == this.webMenuSelected.idMenuJson) {
          this.botonGraficaDinamica = 'SETCD';
        }
        break;
      case 'PI-BARRACE':
        this.grafica = 'barRace';
        this.seccion = 'Precios e inflación';//'Precios e inflación' 'Tasas de interés y sector financiero' 'Sector externo, tasas de cambio y derivados' 'Precios e inflación ciudad';
        this.botonGraficaInicial = 'INICIAL';
        break;
      case 'PI-SPIDER':
        this.grafica = 'barRace';
        this.seccion = 'Precios e inflación ciudad';//'Precios e inflación' 'Tasas de interés y sector financiero' 'Sector externo, tasas de cambio y derivados' 'Precios e inflación ciudad';
        this.botonGraficaInicial = 'INICIAL';
        break;
      case 'TISF-AREA':
        this.grafica = 'barRace';
        this.seccion = 'Tasas de interés y sector financiero';//'Precios e inflación' 'Tasas de interés y sector financiero' 'Sector externo, tasas de cambio y derivados' 'Precios e inflación ciudad';
        this.botonGraficaInicial = 'INICIAL';
        break;
      case 'SETCD-AREA':
        this.grafica = 'barRace';
        this.seccion = 'Sector externo, tasas de cambio y derivados';//'Precios e inflación' 'Tasas de interés y sector financiero' 'Sector externo, tasas de cambio y derivados' 'Precios e inflación ciudad';
        this.botonGraficaInicial = 'INICIAL';
        break;
      default:

        break;
    }
  }

  public abrirPagina(datoRef: string, params?: boolean) {
    var tipoYEnlace = this.obtenerEnlace(datoRef);
    var arrayTipoYEnlace = tipoYEnlace.split("|");
    var tipo: string = arrayTipoYEnlace[0];
    var enlace: string = arrayTipoYEnlace[1];
    if (this.constante.TIPO_URL_INTERNA === tipo) {
      if ('dashboard' === datoRef) {
        if (this.webMenuSelected.enlace_reporte_tabla && params) {
          this.router.navigate([enlace], { queryParams: { 'idDashboard': this.webMenuSelected.enlace_reporte_tabla } });
        } else {
          this.router.navigate([enlace, 'consulta', this.listaInformacionSeries[0].categoriaNivel1]);
        }
      } else {
        this.router.navigate([enlace]);
      }
    } else {
      if ('shopping' == datoRef) {
        enlace = enlace + '#/listado/' + this.listaInformacionSeries[0].categoriaNivel1;
      }
      this.service.windowOpen(enlace, '_blank');
    }
  }

  public abrirDashboard() {
    let navigationExtra: NavigationExtras = {
      state: { objetos: this.webMenuSelected }
    }
    this.router.navigate(['dashboard'], navigationExtra);
  }

  private tileVisualizador(listaId: Array<number>) {
    try {
      listaId.forEach(id => {
        this.listaInformacionSeries.forEach(serie => {
          if (serie.id == id) {
            this.getInfoTile(serie);
            this.tilePaginator.push(serie.id);
          }

        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  private mostrartitulo(titulo: string, padre: number): string {
    if ('1000,2000,3000,4000,5000,6000'.includes(padre.toString())) {
      return '';
    } else {
      return titulo;
    }

  }

  public aplicacionGraficadorSerie() {
    var ulrEnlace: string;
    ulrEnlace = this.urlGraficador + '/#/grafica/' + this.idsSerieGraficador;
    this.service.windowOpen(ulrEnlace, '_blank');
  }

  /****************************SLIDER**************************** */
  public slideIndex = [1, 1];

  public plusSlides(n: number, no: number) {
    this.showSlides(this.slideIndex[no] += n, no);
  }


  public showSlides(n: number, no: number) {
    var tope = this.tilePaginator.length - 1;
    if (n > tope) {
      this.idSerie = this.tilePaginator[0];
      this.slideIndex[no] = 0;
    } else if (n < 0) {
      this.idSerie = this.tilePaginator[tope];
      this.slideIndex[no] = tope;
    } else {
      this.idSerie = this.tilePaginator[n];
    }
    this.tilePaginator.length;
    this.getInformacionSerieSeleccionada();
  }

  private getInformacionSerieSeleccionada() {
    this.listaInformacionSeries.forEach(serie => {
      if (serie.id == this.idSerie) {
        this.getInfoTile(serie);
        this.informacionSerieSelected = serie;
      }
    });
  }

  public getInfoTile(serie: SerieEstadistica) {
    this.nombre = serie.descripcion;
    if (serie.numeroDecimales != 0) {
      this.decimales = serie.numeroDecimales;
    }
    var valorSerie = formatNumber(Number(serie.valor), 'co-ES', '1.' + this.decimales + '-' + this.decimales);
    valorSerie = valorSerie.replace(';', ',')
    var unidadCortaNormalizada = serie.unidadCorta.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    if (unidadCortaNormalizada !== '%') {
      this.valor = valorSerie;
    } else {
      this.valor = valorSerie + serie.unidadCorta;
    }
    this.unidad = serie.unidad;
    this.fecha = serie.fecha;
  }

  private assignSeriesToYAxis(listaSeries: any[]) {
    let seriesLimits: { [key: number]: { [key: string]: number } } = {};
    let seriesAxisPosition: { [key: number]: boolean } = {};
    let seriesUnits: string[] = [];
    let maxValue = 0;
    let minValue = 0;
    if (listaSeries.length > 1) {
      for (let serie of listaSeries) {
        if (serie.data) {
          if (!seriesUnits.includes(serie.unidadCorta))
            seriesUnits.push(serie.unidadCorta);
          seriesLimits[serie.id] = {};
          seriesLimits[serie.id]['max'] = serie.data.reduce((a: any, b: any) => a[1] > b[1] ? a : b)[1];
          seriesLimits[serie.id]['min'] = serie.data.reduce((a: any, b: any) => a[1] < b[1] ? a : b)[1];
          if (seriesLimits[serie.id]['max'] > maxValue)
            maxValue = seriesLimits[serie.id]['max'];
          if (seriesLimits[serie.id]['min'] < minValue && seriesLimits[serie.id]['min'] !== 0)
            minValue = seriesLimits[serie.id]['min'];
        }
      }
      if (seriesUnits.length !== 2) {
        for (let serie of listaSeries) {
          seriesAxisPosition[serie.id] = false;
          if (serie.data && seriesUnits.length > 1) {
            let valor = 1200;
            if (serie.subcategoria === 'Monedas de reserva')
              valor = 5700;
            if (serie.nombre.includes('/USD - Tasa'))
              valor = 25000;
            if (maxValue - seriesLimits[serie.id]['max'] > valor) {
              seriesAxisPosition[serie.id] = true;
            }
          }
        }
      } else {
        for (let serie of listaSeries) {
          seriesAxisPosition[serie.id] = false;
          if (serie.unidadCorta === seriesUnits[0])
            seriesAxisPosition[serie.id] = true;
        }
      }
    } else {
      seriesAxisPosition[listaSeries[0].id] = false;
    }
    return seriesAxisPosition;
  }

  private getSerieChart(serie: SerieEstadistica, numY: number): Highcharts.Series {
    let gs: GraficaSerie = new GraficaSerie();
    let colorLinea = gs.getColor();
    let serieChart: any = {
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: true
          }
        }
      },
      yAxis: numY,
      name: serie.nombre,
      data: serie.data,
      id: serie.id + '',
      color: colorLinea,
      unidadCorta: serie.unidadCorta,
      numeroDecimales: serie.numeroDecimales,
      idPeriodicidad: serie.idPeriodicidad,
      periodicidadNombre: serie.descripcionPeriodicidad,
      fuente: serie.fuente,
      notas: serie.notas,
      type: serie.tipoVisualizacion
    };
    return serieChart;
  }

  public cambiarVistaTabla(id: string, tipo: string) {
    if (isPlatformBrowser(this.platformId)) {
      if ('tabla' == tipo) {
        let divTabla = <HTMLElement>document.getElementById(id + "-grafico");
        divTabla.style.display = 'block';
        let divgrafica = <HTMLElement>document.getElementById(id + "-tabla");
        divgrafica.style.display = 'none';
        let divBotonCP = <HTMLElement>document.getElementById(id + "-buttonCP");
        divBotonCP.style.display = 'block';
        let divBotonIBR = <HTMLElement>document.getElementById(id + "-buttonIBR");
        divBotonIBR.style.display = 'none';
      } else {
        let divTabla = <HTMLElement>document.getElementById(id + "-grafico");
        divTabla.style.display = 'none';
        let divgrafica = <HTMLElement>document.getElementById(id + "-tabla");
        divgrafica.style.display = 'block';
        let divBotonCP = <HTMLElement>document.getElementById(id + "-buttonCP");
        divBotonCP.style.display = 'none';
        let divBotonIBR = <HTMLElement>document.getElementById(id + "-buttonIBR");
        divBotonIBR.style.display = 'block';
      }
    }
  }

  public toggleView() {

    if (Highcharts) {
      const highchartsDataTable = document.querySelector('.highcharts-data-table') as HTMLElement;
      const containerSeriesHighcharts = document.querySelector('.container-series-highcharts') as HTMLElement;
      console.log('highchartsDataTable',highchartsDataTable);
      if (this.showtable) {
        this.nombreBotonTabla = 'Vista tabla';
        highchartsDataTable.style.display = 'none';
        containerSeriesHighcharts.style.display = 'block';
      } else {
        this.nombreBotonTabla = 'Vista gráfica';
        containerSeriesHighcharts.style.display = 'none';
        this.chart!.update({
          exporting: {
            showTable: true // Alternar el valor de showTable
          }
        });
      }
      this.showtable = !this.showtable;

    }
  }

  private obtenerEnlace(select_link: string): string {
    var ulrEnlace: string;
    switch (select_link) {
      case 'catalogo':
        ulrEnlace = 'INTERNO|' + this.constante.urlCatalogo;
        break;
      case 'boletines':
        ulrEnlace = 'INTERNO|' + this.constante.urlBoletines;
        break;
      case 'calendario':
        ulrEnlace = 'INTERNO|' + this.constante.urlCalendario;
        break;
      case 'estadisticaEncuesta':
        ulrEnlace = 'INTERNO|' + this.constante.urlEncuesta;
        break;
      case 'instrucciones':
        ulrEnlace = 'INTERNO|' + this.constante.urlInstrucciones;
        break;
      case 'webservice':
        ulrEnlace = 'INTERNO|' + this.constante.urlWebservice;
        break;
      case 'certificacionCalidad':
        ulrEnlace = 'INTERNO|' + this.constante.urlCertificacionCalidad;
        break;
      case 'graficador':
        ulrEnlace = 'EXTERNO|' + this.urlGraficador;
        break;
      case 'shopping':
        ulrEnlace = 'EXTERNO|' + this.urlBuscador;
        break;
      case 'audiorespuesta':
        ulrEnlace = 'EXTERNO|' + this.urlIndicadores;
        break;
      case 'dashboard':
        ulrEnlace = 'INTERNO|' + this.constante.urlDashboard;
        break;
      case 'historico':
        ulrEnlace = 'EXTERNO|' + this.urlHistorico;
        break;
      default:
        ulrEnlace = 'EXTERNO|#';
    }
    return ulrEnlace;
  }

  private consultarURLServidorExport(llave: string) {
    this.service.consultaParametro(llave).subscribe({
      next: (data) => {
        this.urlServidorExport = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLHistorico() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_SERIE_HITORICO).subscribe({
      next: (data) => {
        this.urlHistorico = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLIndicadores() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_INDICADOR_ECONOMICO_DIA).subscribe({
      next: (data) => {
        this.urlIndicadores = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLGraficador() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_GRAFICADOR).subscribe({
      next: (data) => {
        this.urlGraficador = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLBuscador() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_BUSCADOR).subscribe({
      next: (data) => {
        this.urlBuscador = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  public openDialog() {
    this.dialog.open(DetalleSerieDialogComponent, {
      data: {
        dataKey: this.informacionSerieSelected
      },
      height: '500px',
      width: '1000px'
    });
  }

  public openDialogFeErrata(tipo: string) {
    this.dialog.open(NotaFeErrataComponent, {
      data: {
        dataKey: [this.listaInformacionSeries, tipo, this.informacionSerieSelected]
      },
      height: '500px',
      width: '1000px'
    });
  }

  public openDialogEncuesta() {
    this.encuesta.fechaInicial = this.fechaInicio.getTime();
    this.encuesta.idSerie = this.informacionSerieSelected.id;
    var idCarguePlan = this.webMenuSelected.idCarguePlan;
    var tematica = '';
    tematica = this.validarTitulo();
    if (this.contieneAlgunIdPlan(idCarguePlan, this.constante.LISTA_IDPLAN_ENCUESTA_CERTIFICADA)) {
      this.encuesta.tipoEncuesta = this.constante.TIPO_ENCUESTA_CERTIFICADA;
    } else {
      this.encuesta.tipoEncuesta = this.constante.TIPO_ENCUESTA_BASICA;
    }
    this.encuesta.nombreTematica = tematica;
    this.dialog.open(EncuestaComponent, {
      data: {
        dataKey: this.encuesta
      },
      height: '500px',
      width: '1000px'
    });
  }

  private contieneAlgunIdPlan(idPlan: string, arregloIdPlanCertif: string[]): boolean {
    return arregloIdPlanCertif.some(id => idPlan.includes(id));
  }

  public dataSeriesDivisionGasto: Array<SerieEstadistica> = new Array();
  private getSeriesXDivision() {
    var idSeriesDivision = '15001,15004,15002,15012,15010,15008,15005,15003,15009,15011,15006,15007';
    this.service.getInformacionSerieXTipoDato(idSeriesDivision, 11, 12).subscribe({
      next: (jsonResponse) => {
        this.dataSeriesDivisionGasto = jsonResponse;
      },
      error: (error) => {
        console.log("Error inesperado en getInformacionMenu", error);
      }
    });
  }

  private generarTitulos(serieMenu: any) {
    var nombre: string = serieMenu.enlace_dashboard;
    if (nombre != null && nombre.trim().length > 0) {
      var arregloTitulos: string[] = nombre.split('|');
      if (arregloTitulos.length == 1) {
        this.titulo = arregloTitulos[0];
      } else {
        this.titulo = arregloTitulos[0];
        this.subtitulo = arregloTitulos[1];
      }

    }
  }

  public validarTitulo() {
    if (this.subtitulo == '' || this.subtitulo == null || this.subtitulo == undefined) {
      return this.titulo;
    } else {
      return this.subtitulo;
    }
  }

  private NormalizarTitulos(texto: string) {
    var response: string = '';
    if (texto != null) {
      response = texto.replaceAll('_', ' ');
    }
    return response;
  }

  public exportChart(titulo: string, urlServidorExport: string): Highcharts.ExportingOptions {
    let ue: UtilidadExportXLSX = new UtilidadExportXLSX();
    return {
      enabled: true,
      url: urlServidorExport,
      showTable: this.showtable,
      sourceHeight: 600,
      sourceWidth: 1465,
      csv: {
        dateFormat: '%Y/%m/%d'
      },
      filename: titulo,
      chartOptions: {
        legend: {
          itemWidth: 600,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            fontSize: "10px",
            margin: '30px',
            align: 'center'
          }
        },
        credits: {
          enabled: true,
          position: {
            align: "right",
            verticalAlign: "bottom"
          },
          text: 'Descargado del sistema del Banco de la República ' + new Date().toLocaleString("co-ES")
        }
      },
      menuItemDefinitions: {
        customMenuItem: {
          onclick: () => {
            ue.exportarXLSX(this.chart);
          },
          text: 'Descargar datos en XLS'
        },
      },
      buttons: {
        printButton: {
          titleKey: 'printChart', // Title for print button
          width: 33,
          height: 32,
          symbol: 'url(/estadisticas-economicas/assets/img/iconos/print.png)',
          symbolY: 15,
          align: 'right',
          verticalAlign: 'top',
          onclick: function () {
            Highcharts.charts[0]?.print();
          }
        },
        contextButton: {
          titleKey: 'Opciones de descarga',
          width: 33,
          height: 32,
          symbol: 'url(/estadisticas-economicas/assets/img/iconos/download.png)',
          symbolY: 15,
          align: 'right',
          verticalAlign: 'top',
          menuItems: [
            'downloadCSV',
            'customMenuItem',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG'
          ]
        }
      }
    }
  }
}
